import {
  Button,
  Flex,
  StackingContext,
  Text,
  useMediaQuery
} from '@viveaesthetics/shared'
import React from 'react'
import Image from 'next/image'

import { LINKS } from '@/constants/links'
import { useAppContext } from '@/context/PreloadAppContext'
import { useGetDomainByAppName } from '@/hooks/useGetDomainByAppName'

import { HeaderWrapper, HeaderContent, LinkWrapper } from './styles'

interface HeaderProps {
  hasStaticBackground?: boolean
}

export const Header = ({ hasStaticBackground }: HeaderProps) => {
  const { isDesktop } = useMediaQuery()
  const { branding } = useAppContext()
  const { domain, isLoading: isDomainLoading } = useGetDomainByAppName({
    applicationName: 'CLIENT_360'
  })

  return (
    <StackingContext type="sticky">
      <HeaderWrapper
        id="header-content"
        $hasStaticBackground={hasStaticBackground}
        $space="spacing0"
      >
        <HeaderContent
          $padding={
            isDesktop ? ['spacing12', 'spacing24'] : ['spacing12', 'spacing16']
          }
        >
          <Flex
            template={[1, 1]}
            align="space-between"
          >
            <Flex align="center">
              <LinkWrapper
                href={LINKS.MAIN}
                data-test-id="header-logo-link-to-homepage"
              >
                {branding.images.logoPrimary && (
                  <Image
                    src={branding.images.logoPrimary || ''}
                    alt={`${branding.localizations?.appName} logo`}
                    width={
                      branding.localizations?.appName?.match('Resolute')
                        ? 120
                        : 177
                    }
                    height={20}
                  />
                )}
              </LinkWrapper>
            </Flex>
            <Flex
              justify="flex-end"
              align="center"
              $space="spacing8"
            >
              {isDesktop && (
                <Text
                  type="textS"
                  $color="textSecondary"
                >
                  Have an account?
                </Text>
              )}
              <Button
                variant="link"
                href={`https://${domain}`}
                data-test-id="footer-login-link"
                variantSize="small"
                loading={isDomainLoading}
              >
                Log in
              </Button>
            </Flex>
          </Flex>
        </HeaderContent>
      </HeaderWrapper>
    </StackingContext>
  )
}
